import { TFunction } from "i18next";
import * as yup from "yup";
import { SchemaOf } from "yup";

interface passRefPersonelInfoSubmitValidationProps {
  phoneNumber?: string;
  merchantNo?: string;
  // MBB?: string;
  // CCLastFourDigit?: string;
  Captcha?: string;
}

export const passRefPersonelInfoSubmitValidationSchema = (
  t: TFunction
): SchemaOf<passRefPersonelInfoSubmitValidationProps> =>
  yup.object().shape({
    phoneNumber: yup
      .string()
      .required(t("phone_number_required_validation").toString()),
    merchantNo: yup
      .string()
      .required(t("merchant_number_validation").toString()),
    // MBB: yup.string().required(t("phone_number_required_validation").toString()),
    // CCLastFourDigit: yup.string().required(t("invalid_card_number").toString()),
    Captcha: yup.string().min(4, t("captcha_min_valid").toString()),
  });

interface passRefCardInfoSubmitValidationProps {
  PinDigitEnc?: string;
}

export const passRefCardInfoSubmitValidationSchema = (
  t: TFunction
): SchemaOf<passRefCardInfoSubmitValidationProps> =>
  yup.object().shape({
    PinDigitEnc: yup
      .string()
      .required(t("card_password_placeholder").toString()),
  });

interface passChangeSubmitValidationProps {
  oldPassword?: string;
  newPassword?: string;
  newPasswordAgain?: string;
}

export const passChangeSubmitValidationSchema = (
  t: TFunction
): SchemaOf<passChangeSubmitValidationProps> =>
  yup.object().shape({
    oldPassword: yup
      .string()
      .matches(/^\d+$/, t("password_only _digits_validation").toString())
      .required(t("old_password_placeholder").toString()),
    newPassword: yup
      .string()
      .matches(/^\d+$/, t("password_only _digits_validation").toString())
      .required(t("new_password_placeholder").toString()),
    newPasswordAgain: yup
      .string()
      .oneOf(
        [yup.ref("newPassword"), null],
        t("password_match_valid").toString()
      )
      .matches(/^\d+$/, t("password_only _digits_validation").toString())
      .required(t("new_password_repeat_placeholder").toString()),
  });

interface firstPassChangeSubmitValidationProps {
  newPassword?: string;
  newPasswordAgain?: string;
}

export const firstPassChangeSubmitValidationSchema = (
  t: TFunction
): SchemaOf<firstPassChangeSubmitValidationProps> =>
  yup.object().shape({
    newPassword: yup
      .string()
      .matches(/^\d+$/, t("password_only _digits_validation").toString())
      .required(t("new_password_placeholder").toString()),
    newPasswordAgain: yup
      .string()
      .oneOf(
        [yup.ref("newPassword"), null],
        t("password_match_valid").toString()
      )
      .matches(/^\d+$/, t("password_only _digits_validation").toString())
      .required(t("new_password_repeat_placeholder").toString()),
  });

interface firstPassChangeAdminSubmitValidationProps {
  newPassword?: string;
  newPasswordAgain?: string;
}

export const firstPassChangeAdminSubmitValidationSchema = (
  t: TFunction
): SchemaOf<firstPassChangeAdminSubmitValidationProps> =>
  yup.object().shape({
    newPassword: yup
      .string()
      .matches(/^\d+$/, t("password_only _digits_validation").toString())
      .required(t("new_password_placeholder").toString()),
    newPasswordAgain: yup
      .string()
      .oneOf(
        [yup.ref("newPassword"), null],
        t("password_match_valid").toString()
      )
      .matches(/^\d+$/, t("password_only _digits_validation").toString())
      .required(t("new_password_repeat_placeholder").toString()),
  });
